import React, { useEffect, useState } from "react";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { appConfigServices } from "../../services/AppConfigServices";
import { Dvr } from "@mui/icons-material";
import { handleApiErrorResponses } from "../../utils/ApisErrorHandling";

const UpdatedFeatures = () => {
  const [latestVersionCode, setLatestVersionCode] = useState("");
  const [appType, setAppType] = useState("");
  const [minVersionCode, setMinVersionCode] = useState("");
  const [latestVersionName, setLatestVersionName] = useState("");
  const [status, setStatus] = useState("");
  const [currentData, setCurrentData] = useState([]);

  useEffect(() => {
    const fetchConfigData = async () => {
      try {
        const response = await appConfigServices.getCurrentAndroidAppConfig();
        setCurrentData(response.data.appConfig);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    };
    fetchConfigData();
  }, []);

  const handleUpdate = async (e) => {
    e.preventDefault();

    const updateData = {
      appType,
      latestVersionCode,
      minVersionCode,
      latestVersionName,
      status,
    };
    try {
      await appConfigServices.updateAppConfig(updateData);
      setAppType("");
      setLatestVersionCode("");
      setMinVersionCode("");
      setLatestVersionName("");
      setStatus("");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  return (
    <div className="w-full box-border p-[32px] mt-[92px]">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp; &nbsp;/ &nbsp;
        &nbsp; Profile &nbsp; &nbsp;/ &nbsp; &nbsp; Update-App-Config
      </span>
      <text className="heading">Update App Config</text>
      <hr
        style={{ width: "100%", border: "1px solid rgba(228, 228, 228, 1)" }}
      />

      <div
        style={{ border: "1px solid #e5e5e5" }}
        className="rounded-[20px] mt-8 p-8"
      >
        {/* Table Display */}
        <div className="grid grid-cols-5 gap-12 text-[#797979] text-[18px] px-4 w-full ">
          <div className="flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">App Type</div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">
              Latest Version Code
            </div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">
              Minimum Version Code
            </div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">
              Latest Version Name
            </div>
          </div>
          <div className="col-span-1 flex flex-col">
            <div className="text-[#191919] font-semibold mb-2">Status</div>
          </div>
        </div>

        {/* Display current data in a table */}
        {currentData.map((data, index) => (
          <div
            className={`grid grid-cols-5 gap-12 text-[#797979] text-[16px]  p-4  w-full ${
              index % 2 === 0 ? "bg-[#F5F5F5]" : "bg-white"
            }`}
            key={index}
          >
            <div className="flex flex-col">
              <div className="text-[#191919]">{data.appType}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.latestVersionCode}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.minVersionCode}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.latestVersionName}</div>
            </div>
            <div className="col-span-1 flex flex-col">
              <div className="text-[#191919]">{data.status}</div>
            </div>
          </div>
        ))}
      </div>

      {/* Form for updating the app config */}
      <form onSubmit={handleUpdate} className=" mt-14">
        <div className="grid grid-cols-3 gap-x-5 gap-y-7">
          <div>
            <div className="font-semibold text-[#191919] mb-3">App Type</div>
            <select
              name="app-type"
              style={{ border: "1px solid #d4d4d4" }}
              className="w-full px-5 py-3 rounded-[8px]"
              onChange={(e) => setAppType(e.target.value)}
            >
              <option> Select App Type</option>
              <option value="ANDROIDAPP"> ANDROID APP</option>
              <option value="IOSAPP"> IOS APP</option>
            </select>
          </div>

          <div>
            <div className="font-semibold text-[#191919] mb-3">
              Latest Version Code
            </div>
            <input
              type="text"
              value={latestVersionCode}
              style={{ border: "1px solid #d4d4d4" }}
              className="w-full px-5 py-3 rounded-[8px]"
              onChange={(e) => setLatestVersionCode(e.target.value)}
              required
            />
          </div>

          <div>
            <div className="font-semibold text-[#191919] mb-3">
              Minimum Version Code
            </div>

            <input
              type="text"
              value={minVersionCode}
              style={{ border: "1px solid #d4d4d4" }}
              className="w-full px-5 py-3 rounded-[8px]"
              onChange={(e) => setMinVersionCode(e.target.value)}
              required
            />
          </div>

          <div>
            <div className="font-semibold text-[#191919] mb-3">
              Latest Version Name
            </div>

            <input
              type="text"
              value={latestVersionName}
              style={{ border: "1px solid #d4d4d4" }}
              className="w-full px-5 py-3 rounded-[8px]"
              onChange={(e) => setLatestVersionName(e.target.value)}
              required
            />
          </div>

          <div>
            <div className="font-semibold text-[#191919] mb-3">Status</div>
            <input
              type="text"
              value={status}
              style={{ border: "1px solid #d4d4d4" }}
              className="w-full px-5 py-3 rounded-[8px]"
              onChange={(e) => setStatus(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="flex justify-center mt-5">
          <button
            type="submit"
            style={{ border: "1px solid #017c57" }}
            className=" text-sm font-semibold bg-[#017C57] text-white px-10 py-3 mt-4 rounded-full cursor-pointer"
          >
            UPDATE
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdatedFeatures;
